import Enquiries from "./Enquiries";
export default Enquiries;
